(function () {
	"use strict";

	function MeasureLineBox2d(world, x, y, container, sprite)
	{
		this.Container_constructor();
		this.world = world;
		this.invincibleTimer = 0;
		this.isHook = false;
		this.physicsData = cm.Assets.lib.physicsObjects;
		this.init(world, x, y, container, sprite);
	}

	var p = createjs.extend(MeasureLineBox2d, cjs.Container);

	p.init = function (world, x, y, container, spriteObject)
	{
		var physicsData = this.physicsData[spriteObject];
		this.body = this.buildBodyFromData(physicsData, world, b2.b2Body.b2_staticBody, false);
		this.body.SetPosition(new b2.b2Vec2(x / b2.b2Scale, y / b2.b2Scale));
		this.body.objectContainer = this;
		this.body.SetAngle(Math.toRad(0));
	};

	p.buildBodyFromData = function (data, world, bodyType, bool)
	{
		var fixtures = data.fixtures;
		var body;
		var bodyDef = new b2.b2BodyDef();
		bodyDef.type = bodyType;
		bodyDef.userData = this;
		if (bool)
			bodyDef.bullet = true;

		// create the body
		body = world.world.CreateBody(bodyDef);

		// prepare fixtures
		for (var i = 0; i < fixtures.length; i++) {
			var fixture = fixtures[i];
			var fixtureDef = new b2.b2FixtureDef();
			fixtureDef.density = fixture.density;
			fixtureDef.friction = fixture.friction;
			fixtureDef.restitution = fixture.restitution;
			fixtureDef.filter.categoryBits = fixture.categoryBits;
			fixtureDef.filter.maskBits = fixture.maskBits;
			fixtureDef.filter.groupIndex = fixture.groupIndex;
			fixtureDef.isSensor = fixture.isSensor;
			if (fixture.userData) fixtureDef.userData = fixture.userData;

			if (fixture.fixtureType === "POLYGON") {
				var polygons = fixture.polygons;
				for (var p = 0; p < polygons.length; p++) {
					var vertices = [];
					for (var m = 0; m < polygons[p].length; m++) {
						vertices.push(new b2.b2Vec2(polygons[p][m][0] / b2.b2Scale, polygons[p][m][1] / b2.b2Scale));
					}
					var polygonShape = new b2.b2PolygonShape();
					polygonShape.SetAsArray(vertices, vertices.length);
					fixtureDef.shape = polygonShape;

					body.CreateFixture(fixtureDef);
				}
			} else if (fixture.fixtureType === "CIRCLE") {
				var circleShape = new b2.b2CircleShape(fixture.radius / b2.b2Scale);
				circleShape.SetLocalPosition(new b2.b2Vec2(fixture.center[0] / b2.b2Scale, fixture.center[1] / b2.b2Scale));
				fixtureDef.shape = circleShape;
				body.CreateFixture(fixtureDef);
			}
		}

		return body;
	};

	p.beginContact = function( otherBody, otherFixture, otherUserData, myBody, myFixture, contact ) {

		var fixtureAuserData = otherFixture.GetUserData();
		var fixtureBody = otherFixture.GetBody();
		if(fixtureAuserData === "stackObject"){
			var pos = cm.ViewControl.current.measureLine.sensor.body.GetPosition();
			cm.ViewControl.current.setMeasureLine(pos);
		}

	};


	p.update = function ()
	{

	};

	p.kill = function ()
	{
		this.world.world.DestroyBody(this.body);
	};

	cm.MeasureLineBox2d = cjs.promote(MeasureLineBox2d, "Container");
})();